import { TemplateType } from "@commons-monorepo/index";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { ToppingsSkin1 } from "./skins/toppings-skin-1";
import { ToppingsType } from "./type";

const Toppings = (props: ToppingsType) => {
  const { theme } = useGlobalStyles();

  return (
    <>
      {theme.template.PRODUCT_TOPPING_SELECTOR ===
        TemplateType.PRODUCT_TOPPING_SELECTOR_SKIN_1 && (
        <ToppingsSkin1 {...props} />
      )}
    </>
  );
};

export default Toppings;
